module.exports = __webpack_public_path__ + "static/media/wrapper-finished-puzzling.38c05a56.png";